import { render, staticRenderFns } from "./profiles-list.vue?vue&type=template&id=1c38444c&scoped=true&"
import script from "./profiles-list.vue?vue&type=script&lang=js&"
export * from "./profiles-list.vue?vue&type=script&lang=js&"
import style0 from "./profiles-list.vue?vue&type=style&index=0&id=1c38444c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c38444c",
  null
  
)

export default component.exports